module.exports = {
  width: 122,
  height: 34,
  bytes: 6814,
  type: "svg",
};
module.exports.toString = function() {
  return __webpack_public_path__ + undefined;
};